module.exports = __webpack_public_path__ + "media/site_templates/www.localcleaners.net.au/images/feature_2-93f8f428cba2ef1395339cb1b0755d86.jpeg";